<template>
  <ul class="notranslate">
    <li
      v-for="judge in judgeQueue"
      :key="judge.judgeId"
      class="text-sm border p-1 pl-3 border-primary-50 dark:border-dark-200"
    >
      <div>
        <span class="pr-1">{{ judge.problemId }}:</span>
        {{ judge.userId }}
      </div>
      <div class="text-xs flex justify-between">
        <judge-badge :status="judge.status" />
        <span class="mr-2">{{ timestampToDate(judge.submissionDate) }}</span>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import JudgeBadge from '@/presentation/components/Text/JudgeBadge.vue'
import { useRecentJudgeListPresenter } from '@/presentation/composables/judge/useRecentJudgeListPresenter'
import timestampToDate from '@/util/date/timestampToDate'

export default defineComponent({
  components: {
    JudgeBadge
  },
  setup(props) {
    const { recentJudgeList } = useRecentJudgeListPresenter()

    const judgeQueue = computed(() => {
      return (recentJudgeList.value as unknown[] as JudgeRecord[]).filter(jr => jr.judgeType !== 0).filter(isUniq)
    })
    const isUniq = (jr: JudgeRecord, idx: number, arr: JudgeRecord[]): boolean => {
      return arr.findIndex(e => e.judgeId === jr.judgeId) === idx
    }

    return {
      judgeQueue,
      timestampToDate
    }
  }
})
</script>
